import { offersService } from '@/infrastructure/Factory'
import OffersResponse from '../../services/offers/OffersReponse'
import { normalizeFilters } from '@/infrastructure/Utils'
import OffersFilter from '../../services/offers/OffersFilter'

export default {
  async initialize({ commit }) {
    const offers = await offersService.getInitialOffers()
    commit('updateOffersSuccess', offers)
  },

  async initializeRevamp({ commit, getters }) {
    const sliders = await offersService.getInitialOffersRevamp()

    const {
      slides: { offers }
    } = sliders
    if (!offers || offers.length === 0) {
      const data = await offersService.getCategoriesOffers(OffersFilter.empty())
      const emptySlidersOffers = new OffersResponse({
        total: data.total,
        results: data.offers,
        facets: getters.facets,
        filter: OffersFilter.empty()
      })
      commit('updateOffersSuccess', emptySlidersOffers)
      commit('updateEmptySliders', true)
    }
    commit('updateOffersSuccessRevamp', sliders)
  },

  async getRegions({ commit }) {
    const regions = await offersService.getRegions()
    commit('updateRegionsSuccess', regions)
  },

  async getCountriesAndCities({ commit }) {
    const response = await offersService.getCountriesAndCities()

    commit('updateCountriesAndCitiesSuccess', response)
  },

  async changeDateRange({ getters, commit, dispatch }, dateRange) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.changeDateRange(dateRange)
    )
    commit('updateOffersSuccess', offers)
    if (offers.filter.hasDates()) {
      dispatch('trackOfferFilterApplied', {
        offerFilterType: 'date',
        offerFilterLengthOfStay: offers.filter.lengthOfStay().toString()
      })
    }
  },

  async filterByGeoLocation({ getters, commit }, position) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.clearLocationFilters().addLocation(position)
    )
    commit('updateOffersSuccess', offers)
  },

  async filterByRegion({ getters, commit }, region) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.clearLocationFilters().addRegion(region)
    )
    commit('updateOffersSuccess', offers)
  },

  async filterByCity({ getters, commit }, city) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.clearLocationFilters().addCity(city)
    )
    commit('updateOffersSuccess', offers)
  },

  async filterByCountry({ getters, commit }, country) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.clearLocationFilters().addCountry(country)
    )
    commit('updateOffersSuccess', offers)
  },

  async selectSingleCategory({ getters, commit, dispatch }, category) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.addSingleCategory(category)
    )
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'hotelType',
      offerFilterTripType: category.code
    })
  },

  async selectCategory({ getters, commit, dispatch }, category) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.addCategory(category)
    )
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'hotelType',
      offerFilterTripType: category.code
    })
  },

  async unselectCategory({ getters, commit }, category) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.removeCategory(category)
    )
    commit('updateOffersSuccess', offers)
  },

  async selectCountry({ getters, commit, dispatch }, country) {
    const offers = await offersService.getOffers(getters.facets, getters.filter.addCountry(country))
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'location',
      offerFilterLocation: country.name
    })
  },

  async selectLocation({ dispatch }, location) {
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'location',
      offerFilterLocation: location.name
    })
  },

  async selectCity({ getters, commit, dispatch }, { country, city }) {
    const offers = await offersService.getOffers(getters.facets, getters.filter.addCity(city))
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'location',
      offerFilterLocation: `${city.name}, ${country.name}`
    })
  },

  async updateMoreFilters({ getters, commit, dispatch }, { brands, points }) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.addBrands(brands).rewardsOnly(points)
    )
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', { offerFilterType: 'brand', offerFilterBrand: brands[0].code })
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'rewardsOnly',
      isOfferFilterRr: points.toString()
    })
  },

  async selectBrand({ getters, commit, dispatch }, brand) {
    const offers = await offersService.getOffers(getters.facets, getters.filter.addBrand(brand))
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', { offerFilterType: 'brand', offerFilterBrand: brand.code })
  },

  async unselectBrand({ getters, commit }, brand) {
    const offers = await offersService.getOffers(getters.facets, getters.filter.removeBrand(brand))
    commit('updateOffersSuccess', offers)
  },

  async changeIsRewardsOnly({ getters, commit, dispatch }) {
    const offers = await offersService.getOffers(getters.facets, getters.filter.toggleRewardsOnly())
    commit('updateOffersSuccess', offers)
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'rewardsOnly',
      isOfferFilterRr: offers.filter.isRewardsOnly.toString()
    })
  },

  async clearLocationFilters({ getters, commit }) {
    const offers = await offersService.getOffers(
      getters.facets,
      getters.filter.clearLocationFilters()
    )
    commit('updateOffersSuccess', offers)
  },

  async clearFilters({ getters, commit }) {
    const offers = await offersService.getOffers(getters.facets)
    commit('updateOffersSuccess', offers)
  },

  async nextPage({ getters, commit, dispatch }) {
    const offers = await offersService.getOffers(getters.facets, getters.filter.next())
    commit('nextPageSuccess', offers)
    commit('updateSessionStorage', offers)
    dispatch('trackLoadMoreOffers')
  },
  async seeAll({ commit, getters }, filters) {
    const offers = await offersService.getOffers(getters.facets, normalizeFilters(filters))
    commit('updateOffersSuccess', offers)
    commit('updateSeeAllFilter', true)
    if (filters?.countries && filters?.countries.length > 1 && filters?.countries[0] === 'AL') {
      commit('updateSeeAllEurope', true)
    }
  },

  async trackLoadMoreOffers() {
    global.trackingService.track(global.trackingEvents.LOAD_MORE_OFFERS)
  },

  async trackOfferFilterApplied({ getters }, eventData) {
    global.trackingService.track(
      global.trackingService.eventBuilder(global.trackingEvents.OFFER_FILTER_APPLIED, eventData)
    )
  },

  setPlace({ commit }, location) {
    commit('setPlace', location)
  },

  setIsAllFilterEurope ({ commit }, value) {
    commit('updateSeeAllEurope', value)
  }

}
